
<div class="row mt-2">
  <div class="col-12" *ngIf="selectedMountPoint && loading">
    <div class="subsection">
      <div class="d-flex justify-content-between align-items-center mb-2 subheader">
        <h4 class="m-0 subsection-title">Edit MountPoint</h4>
        <button type="button" class="btn btn-sm btn-link text-decoration-none" (click)="onBack()" aria-label="Close">
          <span class="material-icons">close</span>
        </button>
      </div>

      <form (ngSubmit)="onSubmit()" class="row g-2 form-edit">
        <div class="row g-2">
          <div class="col-12">
            <div class="row row-cols-1 row-cols-md-4 g-3 mb-3">
              <div class="col">
                <label for="stMountPoint" class="form-label d-flex align-items-center">MountPoint
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['mountpoint'].description}}">info</span>
                </label>
                <input type="text" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stMountPoint" [(ngModel)]="selectedMountPoint.stMountPoint" name="stMountPoint" [disabled]="!canEdit">
              </div>
              <div class="col">
                <label for="stIdentifier" class="form-label d-flex align-items-center">Identifier
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['identifier'].description}}">info</span>
                </label>
                <input type="text" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stIdentifier" [(ngModel)]="selectedMountPoint.stIdentifier" name="stIdentifier" [disabled]="!canEdit">
              </div>
              <div class="col">
                <label for="stFormat" class="form-label d-flex align-items-center">Format
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['format'].description}}">info</span>
                </label>
                <input type="text" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stFormat" [(ngModel)]="selectedMountPoint.stFormat" name="stFormat" [disabled]="!canEdit">
              </div>
              <div class="col">
                <label for="stCarrier" class="form-label d-flex align-items-center">Carrier
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['carrier'].description}}">info</span>
                </label>
                <input type="number" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stCarrier" [(ngModel)]="selectedMountPoint.stCarrier" name="stCarrier" [disabled]="!canEdit">
              </div>
            </div>

            <div class="row row-cols-1 row-cols-md-4 g-3 mb-3">
              <div class="col">
                <label for="stFormatDetails" class="form-label d-flex align-items-center">Format Details
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['formatDetails'].description}}">info</span>
                </label>
                <input type="text" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stFormatDetails" [(ngModel)]="selectedMountPoint.stFormatDetails" name="stFormatDetails" [disabled]="!canEdit">
              </div>
              <div class="col">
                <label for="stNavSystem" class="form-label d-flex align-items-center">Nav System
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['navSystem'].description}}">info</span>
                </label>
                <input type="text" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stNavSystem" [(ngModel)]="selectedMountPoint.stNavSystem" name="stNavSystem" [disabled]="!canEdit">
              </div>
              <div class="col">
                <label for="stNetwork" class="form-label d-flex align-items-center">Network
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['network'].description}}">info</span>
                </label>
                <input type="text" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stNetwork" [(ngModel)]="selectedMountPoint.stNetwork" name="stNetwork" [disabled]="!canEdit">
              </div>
              <div class="col">
                <label for="stCountry" class="form-label d-flex align-items-center">Country
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['country'].description}}">info</span>
                </label>
                <input type="text" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stCountry" [(ngModel)]="selectedMountPoint.stCountry" name="stCountry" [disabled]="!canEdit">
              </div>
            </div>

            <div class="row row-cols-1 row-cols-md-4 g-3 mb-3">
              <div class="col">
                <label for="stLatitude" class="form-label d-flex align-items-center">Latitude
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['latitude'].description}}">info</span>
                </label>
                <input type="number" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stLatitude" [(ngModel)]="selectedMountPoint.stLatitude" name="stLatitude" [disabled]="!canEdit">
              </div>
              <div class="col">
                <label for="stLongitude" class="form-label d-flex align-items-center">Longitude
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['longitude'].description}}">info</span>
                </label>
                <input type="number" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stLongitude" [(ngModel)]="selectedMountPoint.stLongitude" name="stLongitude" [disabled]="!canEdit">
              </div>
              <div class="col">
                <label for="stNmea" class="form-label d-flex align-items-center">NMEA
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['nmea'].description}}">info</span>
                </label>
                <input type="number" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stNmea" [(ngModel)]="selectedMountPoint.stNmea" name="stNmea" [disabled]="!canEdit">
              </div>
              <div class="col">
                <label for="stSolution" class="form-label d-flex align-items-center">Solution
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['solution'].description}}">info</span>
                </label>
                <input type="number" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stSolution" [(ngModel)]="selectedMountPoint.stSolution" name="stSolution" [disabled]="!canEdit">
              </div>
            </div>

            <div class="row row-cols-1 row-cols-md-4 g-3 mb-3">
              <div class="col">
                <label for="stGenerator" class="form-label d-flex align-items-center">Generator
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['generator'].description}}">info</span>
                </label>
                <input type="text" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stGenerator" [(ngModel)]="selectedMountPoint.stGenerator" name="stGenerator" [disabled]="!canEdit">
              </div>
              <div class="col">
                <label for="stCompression" class="form-label d-flex align-items-center">Compression
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['compression'].description}}">info</span>
                </label>
                <input type="text" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stCompression" [(ngModel)]="selectedMountPoint.stCompression" name="stCompression" [disabled]="!canEdit">
              </div>
              <div class="col">
                <label for="stAuthentication" class="form-label d-flex align-items-center">Authentication
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['authentication'].description}}">info</span>
                </label>
                <input type="text" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stAuthentication" [(ngModel)]="selectedMountPoint.stAuthentication" name="stAuthentication" [disabled]="!canEdit">
              </div>
              <div class="col">
                <label for="stFee" class="form-label d-flex align-items-center">Fee
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['fee'].description}}">info</span>
                </label>
                <input type="text" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stFee" [(ngModel)]="selectedMountPoint.stFee" name="stFee" [disabled]="!canEdit">
              </div>
            </div>

            <div class="row row-cols-1 row-cols-md-4 g-3 mb-3">
              <div class="col">
                <label for="stBitrate" class="form-label d-flex align-items-center">Bitrate
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['bitrate'].description}}">info</span>
                </label>
                <input type="number" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stBitrate" [(ngModel)]="selectedMountPoint.stBitrate" name="stBitrate" [disabled]="!canEdit">
              </div>
              <div class="col">
                <label for="stMisc" class="form-label d-flex align-items-center">Misc
                  <span class="material-icons ms-1 text-muted" matTooltip="{{helpData['misc'].description}}">info</span>
                </label>
                <input type="text" [style.color]="canEdit ? 'blue' : 'inherit'" class="form-control" id="stMisc" [(ngModel)]="selectedMountPoint.stMisc" name="stMisc" [disabled]="!canEdit">
              </div>
              <div class="col">
                <label class="form-label d-flex align-items-center">Is Active?
                  <span class="material-icons ms-1 text-muted" matTooltip="MountPoint active status">info</span>
                </label>
                <div class="form-check mt-1">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="selectedMountPoint.active" name="active" [disabled]="!canEdit">
                </div>
              </div>
              <div class="col"></div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-end">
            <button type="button" class="btn btn-primary" (click)="onBack()">Close (but not yet save to DB)</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>